module.exports = __webpack_public_path__ + "static/media/soundwave.33b1dbc3.png";